import CookiesRaw from 'js-cookie';
import { UrlGenerator } from '../UrlGenerator'; // Для куки sopr_utm используется tornado.escape.url_escape с флагом plus, заменяющим %20 на знак +

var Cookies = CookiesRaw.withConverter({
  read: function read(valueRaw, name) {
    var value = valueRaw;

    if (name === 'sopr_utm') {
      value = value.replace(/\+/g, ' ');
    }

    return value.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
  }
});
export function generateOneLinkUrl(oneLinkURL, pidStaticValue, deepLinkSub5Value) {
  if (!oneLinkURL) {
    return null;
  }

  var soprUtm = null;

  try {
    var soprUtmCookieValue = Cookies.get('sopr_utm');
    soprUtm = soprUtmCookieValue ? JSON.parse(soprUtmCookieValue) : null; // eslint-disable-next-line no-empty
  } catch (_unused) {}

  var generator = new UrlGenerator({
    oneLinkURL: oneLinkURL,
    pidStaticValue: soprUtm && soprUtm['utm_source'] || pidStaticValue,
    pidKeysList: ['utm_source'],
    campaignKeysList: ['utm_campaign'],
    campaignStaticValue: soprUtm && soprUtm['utm_campaign'],
    gclIdParam: 'af_sub4'
  });
  generator.setAfSub1('utm_medium', soprUtm && soprUtm['utm_medium']);
  generator.setAfSub2('utm_content', soprUtm && soprUtm['utm_content']);
  generator.setAfSub3('utm_term', soprUtm && soprUtm['utm_term']);
  generator.setAfSub4('gclid', Cookies.get('gclid'));
  generator.setDeepLinkSub4(Cookies.get('_CIAN_GK'));
  generator.setDeepLinkSub5(deepLinkSub5Value);
  return generator.generateUrl() || oneLinkURL;
}